import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CachedIcon from "@mui/icons-material/Cached";
import SearchIcon from "@mui/icons-material/Search";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import { useGlobalContext } from "../../../Context/GlobalContext";
import { Modal } from "react-responsive-modal";
import Select from "react-select";
import PersonIcon from "@mui/icons-material/Person"
import { IoMdArrowDropright } from "react-icons/io";

const ContactInformation = () => {
  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };
  const [isOpen, setIsOpen] = useState(false);

  const toggleModal15 = () => {
    setIsOpen15(!isOpen15);
  };
  const [isOpen15, setIsOpen15] = useState(false);
  const [taskStatus, setTaskStatus] = useState({
    name: "",
    color: "#000000",
    order: "",
    isHiddenFor: [],
    canBeChangedTo: [],
  });

  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#F4F5F9",
      borderColor: "#E2E8F0",
      minHeight: "38px",
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#E2E8F0",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      fontSize: "14px",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#4A5568",
      ":hover": {
        backgroundColor: "#CBD5E0",
        color: "#2D3748",
      },
    }),
  };

  const [allStaff, setAllStaff] = useState();

  const [open, setOpen] = useState(false);

  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);

  const handleSelectChange = (event) => {
    setRowsToShow(Number(event.target.value));
  };
  const [rowsToShow, setRowsToShow] = useState(25);

  const [exportFormat, setExportFormat] = useState("");
  const [departments, setDepartments] = useState([]);

  const handleExport = () => {
    if (exportFormat === "CSV") exportCSV();
    else if (exportFormat === "PDF") exportPDF();
    else if (exportFormat === "Print") printDepartments();
  };

  const exportCSV = () => {
    const csvData = departments
      .map((dep) => `${dep.department_name}, Total Users: 1`)
      .join("\n");
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "departments.csv");
  };

  const exportPDF = () => {
    const doc = new jsPDF();
    doc.text("Department List", 20, 10);
    departments.forEach((dep, index) => {
      doc.text(
        `${index + 1}. ${dep.department_name} (Total Users: 1)`,
        10,
        20 + index * 10
      );
    });
    doc.save("departments.pdf");
  };

  const printDepartments = () => {
    const printContent = departments
      .map((dep) => `${dep.department_name} (Total Users: 1)`)
      .join("\n");
    const newWindow = window.open();
    newWindow.document.write(`<pre>${printContent}</pre>`);
    newWindow.document.close();
    newWindow.print();
  };

  const [clientData, setClientData] = useState([]);
  const { baseUrl, openToast } = useGlobalContext();
  const fetchDetail = async () => {
    const result = await fetch(baseUrl + "client");
    if (result.status == 200) {
      const res = await result.json();
      console.log(res);
      setClientData(res);
    } else {
      openToast(result.message);
    }
  };

  useEffect(() => {
    fetchDetail();
  }, []);
  const [isOn, setIsOn] = useState(false);

  const toggleSwitch = () => {
    setIsOn(!isOn);
  };
  const [isOn2, setIsOn2] = useState(false);

  const toggleSwitch2 = () => {
    setIsOn2(!isOn2);
  };
  const [isOn3, setIsOn3] = useState(false);

  const toggleSwitch3 = () => {
    setIsOn3(!isOn3);
  };
  return (
    <div className="bg-[#fff] mt-[27px] px-4 py-6 pt-0">
      <div className="flex items-center gap-[10px] mb-[14px] import-customers">
        <Link
          to="/Clients"
          className="flex justify-center items-center gap-[3px] allcrm-btn font-medium text-center client-add focus:outline-none newcustomers"
        >
          <AddIcon className="newadd" />  Clients
        </Link>

        <Link
          to="/contact-information"
          className="bg-[#f4f2f2] dark:hover:bg-blue-700 dark:bg-blue-600 p-[8px] rounded-lg dark:focus:ring-blue-800 font-medium text-[#000] text-[14px] text-center client-add focus:outline-none"
        >
          <PersonIcon className="mr-[5px] newadd" />
          Contacts
        </Link>
      </div>
      <div className="bg-white shadow-cs p-[20px] rounded-lg table-section">

        <h2 className="mb-[14px] font-medium text-[18px]">Contact Information</h2>

        <div className="flex sm:flex-row flex-col justify-between items-center gap-2 mb-4">
          <div className="flex sm:flex-row flex-col flex-wrap items-center gap-2 w-full">
            <select
              onChange={handleSelectChange}
              className="border-[#e5e7eb] shadow-sm p-[7px] border rounded-md w-full sm:w-[60px] text-[14px] focus:outline-none"
            >
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="120">120</option>
            </select>
            <select
              onChange={(e) => setExportFormat(e.target.value)}
              className="border-[#e5e7eb] shadow-sm p-[7px] border rounded-md w-full sm:w-[67px] text-[14px] focus:outline-none"
            >
              <option value="CSV">CSV</option>
              <option value="PDF">PDF</option>
              <option value="Print">Print</option>
            </select>

            <button
              onClick={handleExport}
              className="bg-[#27004a] p-[7px] rounded-md w-full sm:w-[83px] text-[14px] text-white cursor-pointer"
            >
              Export File
            </button>
            <button
              className="border-[#e5e7eb] shadow-sm p-[7px] border rounded-lg w-full sm:w-[123px] text-[14px]"
              onClick={onOpenModal}
            >
              Bulk Action <CachedIcon className="newsidebar-icon" />{" "}
            </button>
          </div>
          <div className="relative flex flex-wrap justify-end items-center gap-2 w-full">
            <input
              type="text"
              placeholder="Search"
              className="border-1 p-[10px] pr-7 border rounded-3xl w-[100%] md:w-[200px] h-[38px] text-[#000] text-[15px] ] focus:outline-none"
            />
            <SearchIcon
              className="right-[10px] absolute search-icon font-thin text-[#000] text-[#dddddd; ]"
            />{" "}
          </div>
        </div>

        <div className="border-[#dcdbdb] bg-white shadow-cs border rounded-lg w-full overflow-x-auto">
          <table className="border-[#dcdbdb] border-collapse border rounded-lg w-full overflow-hidden table-auto">
            <thead
              className="border-gray-300 shadow-md border cursor-pointer"
              onClick={toggleAccordion}
            >
              <tr>
                <th className="flex justify-center p-2 border-r font-medium text-center text-xs whitespace-nowrap">
                  <IoMdArrowDropright
                    className={`text-[20px] transition-transform duration-200 ${isOpen ? "rotate-90 text-[black]" : "rotate-0"
                      }`}
                  />
                </th>
                <th className="p-2 border-r font-medium text-center text-xs whitespace-nowrap">
                  #
                </th>
                <th className="p-2 border-r font-medium text-center text-xs whitespace-nowrap">
                  Name
                </th>
                <th className="p-2 border-r font-medium text-center text-xs whitespace-nowrap">
                  Company
                </th>
                <th className="p-2 border-r font-medium text-center text-xs whitespace-nowrap">
                  Primary Contact
                </th>
                <th className="p-2 border-r font-medium text-center text-xs whitespace-nowrap">
                  Primary Email
                </th>
                <th className="p-2 border-r font-medium text-center text-xs whitespace-nowrap">
                  Phone
                </th>
                <th className="p-2 border-r font-medium text-center text-xs whitespace-nowrap">
                  Active
                </th>
                <th className="p-2 border-r font-medium text-center text-xs whitespace-nowrap">
                  Groups
                </th>
                <th className="p-2 border-r font-medium text-center text-xs whitespace-nowrap">
                  Date Created
                </th>
                <th className="p-2 font-medium text-center text-xs">Action</th>
              </tr>
            </thead>
            {isOpen && (
              <tbody className={`transition-body ${isOpen ? "open" : ""}`}>
                {clientData?.map((client, index) => {
                  return (
                    <tr className="border">
                      <td>{client.name}</td>
                      <td>pa</td>
                      <td>{client.email}</td>
                      <td>brandpa</td>
                      <td>{client.mobile}</td>
                      <td>Demo</td>
                      <td>4 Weeks ago</td>
                      <td>
                        <div
                          className={`${isOn3 ? "bg-[#27004a]" : "bg-[#e6e0e0]"
                            } relative inline-block w-12 h-6 rounded-full transition-colors duration-300 ease-in-out cursor-pointer`}
                          onClick={toggleSwitch3}
                        >
                          <span
                            className={`${isOn3
                              ? "translate-x-6 mr-[21px] "
                              : "translate-x-0 mr-[21px]"
                              } inline-block w-6 h-6 bg-[#d5cdcd] rounded-full transform transition-transform duration-300 ease-in-out`}
                          />
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            )}
          </table>
        </div>

        <div className="flex sm:flex-row flex-col justify-between items-center gap-2 sm:gap-0 p-[10px] pt-5 pb-[0] w-[100%]">
          <p className="text-[#a5a1a1] text-[14px]">
            Showing 1 to {rowsToShow} of {departments.length} entries
          </p>
          <div className="flex gap-2 pt-0 pr-4 pb-0 pl-4 border rounded-md pagination">
            <Link to="#" className="pt-2 pb-[8px] text-[12px]">
              Previous
            </Link>
            <span className="flex items-center bg-[#27004a] pr-3 pl-3 text-[12px] text-white">
              1
            </span>
            <Link to="#" className="pt-2 pb-[8px] text-[12px]">
              Next
            </Link>
          </div>
        </div>
        {/* Bulk action modal */}
        <Modal open={open} onClose={onCloseModal} center>
          <div className="border-[#dbdbdb] pb-[20px] border-b">
            <h2>Bulk Actions</h2>
          </div>
          <div className="flex items-center gap-[8px] mt-[32px] mb-[30px]">
            <input type="checkbox" />
            <p className="text-[14px]">Mass Delete</p>
          </div>
          <div className="w-[100%]">
            <Select
              isMulti
              name="isHiddenFor"
              className="basic-multi-select"
              classNamePrefix="select"
              styles={customStyles}
            />
          </div>

          <p className="mt-[10px] text-[14px] text-[red]">
            if you do not select any groups assigned to the selected customers
            will be removed.
          </p>

          <div className="flex justify-end gap-[10px] mt-[24px] pr-[10px] pb-3">
            <button className="second-btn">Confirm </button>
          </div>
        </Modal>
        {/* Bulk action modal end */}
      </div>
    </div>
  );
};

export default ContactInformation;
